import { call, put } from 'redux-saga/effects';
import { AxiosError, AxiosResponse } from 'axios';

// Response / Request
import { Result } from '@models/common/resultResponse';
import { KeyValue } from '@/main/models/common';

// Redux
import { GetDomainQuoteStatus, GetQuoteStatus, saveQuoteStatus } from './index';

// Api's
import { quoteApi } from '../../api';
import { errorBoundaryReduxSaga, renderErrorReduxSaga } from '@/main/services/utils';

export function* getQuoteStatusSaga(action: GetQuoteStatus) {
  try {
    const isUserControl = action?.payload?.isUserControl ?? null;
    const response: AxiosResponse<Result<KeyValue[]>> = yield call(
      quoteApi.getDomain,
      isUserControl
    );

    if (response.data.result) {
      yield put(saveQuoteStatus(response.data.result, false, null));
    }
  } catch (exception) {
    if (exception instanceof AxiosError) {
      const resultError = errorBoundaryReduxSaga(exception);
      renderErrorReduxSaga(resultError);

      yield put(saveQuoteStatus(null, true, resultError.messagesDataError));
    }
  }
}

export function* getQuoteStatusDomainSaga(action: GetDomainQuoteStatus) {
  try {
    const response: AxiosResponse<Result<KeyValue[]>> = yield call(
      quoteApi.domainQuoteStatus
    );
    if (response.data.result) {
      yield put(saveQuoteStatus(response.data.result, false, null, action.payload.keyReducer));
    }
  } catch (exception) {
    if (exception instanceof AxiosError) {
      const resultError = errorBoundaryReduxSaga(exception);
      renderErrorReduxSaga(resultError);

      yield put(saveQuoteStatus(null, true, resultError.messagesDataError, action.payload.keyReducer));
    }
  }
}